import Vue from 'vue';
import VueRouter from 'vue-router';
import Login from '@/views/Login/LoginIndex';

Vue.use(VueRouter);

//静态路由
export const defaultRoutes = [
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      title: '登录', //用于浏览器页签显示title
      icon: null //用于系统左侧菜单显示图标
    },
    hidden: true
  },
  {
    path: '',
    component: () => import('@/layout/MainLayout'),
    children: [
      {
        path: 'homeboard',
        name: 'homeboard',
        component: () => import('@/views/HomeBoard/HomeIndex'),
        meta: { title: '首页', icon: 'home' }
      }
    ]
  }
];

//创建vueRouter实例
const router = new VueRouter({
  mode: 'hash',
  routes: defaultRoutes
});

export default router;
